module.exports = __webpack_public_path__ + "static/media/PA-Icon-Spielplatz-pos.dbd836d5.svg";